import Image from 'next/legacy/image'
import { useRouter } from 'next/router'
import { ReactSVG } from 'react-svg'
import { t } from '../../../../../utils'
import { Song } from '../../../../../__generated__/graphql'
import StoreSongActions from './StoreSongActions'
import styles from './_storeSongBanner.module.scss'

interface StoreSongBannerProps {
  song: Song
}

const StoreSongBanner: React.FC<StoreSongBannerProps> = ({ song }) => {
  const router = useRouter()

  return (
    <div className={styles.storeSongBanner}>
      <div className="section">
        <div className="container is-flex">
          <button
            className={styles.storeSongBannerBack}
            onClick={() => router.back()}
          >
            <ReactSVG src="../../images/store/songs.svg" />
            <div className={styles.storeSongBannerBackTitle}>
              {t('Go Back')}
            </div>
          </button>
          <StoreSongActions song={song} />
        </div>
      </div>
      <div className={styles.storeSongBannerImgContainer}>
        <Image
          src={song.album.cover.medium}
          alt={`${song.title} background image`}
          priority={true}
          quality={50}
          layout={'fill'}
        ></Image>
      </div>
    </div>
  )
}

export default StoreSongBanner
